const FormSupport = () => {
	let view = {
		id: null,
		name: null,
		code: null,
		directSale: null,
		superiorName: null,
		superiorCode: null,
	};

	let dto = {
		id: null,
		name: null,
		code: null,
		directSale: null,
		superiorName: null,
		superiorCode: null,
	};

	const information = [
		{ ids: ["FormNetworkMarketer_id"], value: "id" },
		{ ids: ["FormNetworkMarketer_fullName"], value: "fullName" },
		{ ids: ["FormNetworkMarketer_networkMarketerCode"], value: "networkMarketerCode" },
		{ ids: ["FormNetworkMarketer_directSale"], value: "directSale" },
		{
			ids: ["FormNetworkMarketer_superiorFormNetworkMarketer", "FormNetworkMarketer_id"],
			value: "superiorFormNetworkMarketer.id",
		},
		{
			ids: ["FormNetworkMarketer_superiorFormNetworkMarketer", "FormNetworkMarketer_fullName"],
			value: "superiorFormNetworkMarketer.fullName",
		},
		{
			ids: [
				"FormNetworkMarketer_superiorFormNetworkMarketer",
				"FormNetworkMarketer_networkMarketerCode",
			],
			value: "superiorFormNetworkMarketer.networkMarketerCode",
		},
	];

	const fieldNameAddresses = {
		FormNetworkMarketer: {
			FormNetworkMarketer_fullName: ["fullName", "superiorFormNetworkMarketer.fullName"],
			FormNetworkMarketer_id: ["id", "superiorFormNetworkMarketer.id"],
			FormNetworkMarketer_superiorFormNetworkMarketer: ["superiorFormNetworkMarketer"],
			FormNetworkMarketer_networkMarketerCode: [
				"networkMarketerCode",
				"superiorFormNetworkMarketer.networkMarketerCode",
			],
			FormNetworkMarketer_directSale: ["directSale"],
		},
	};

	return [information, dto, view, fieldNameAddresses];
};

export default FormSupport;
